<template>
    <v-layout class="row">
        <v-flex xs4 class="text-sm-left text-center">
            <v-btn
                icon
                :aria-label="previousMonthDescription"
                color="primary"
                id="previousMonth"
                @click="navigateMonth('previousMonth')"
            >
                <v-icon dark large>
                    keyboard_arrow_left
                </v-icon>
            </v-btn>
        </v-flex>
        <v-flex xs4 align-self-center class="text-center title" id="calendar-title">
            {{ calendarTitle }}
        </v-flex>
        <v-flex xs4 class="text-sm-right text-center">
            <v-btn
                icon
                :aria-label="nextMonthDescription"
                color="primary"
                id="nextMonth"
                @click="navigateMonth('nextMonth')"
            >
                <v-icon dark large>
                    keyboard_arrow_right
                </v-icon>
            </v-btn>
        </v-flex>
    </v-layout>
</template>
<script lang="js">

import { mapGetters } from 'vuex';
import { upperFirst } from 'lodash';
import { addMonths, format } from 'date-fns';
import frLocale from 'date-fns/locale/fr';
import { removeHTMLTags } from '@/utils';

export default {
    name: 'navigate-months-buttons',
    props: {
        start: { required: true, type: String },
        monthHasAllowedAvailabilities: { required: true, type: Number },
    },
    data: () => ({
        previousMonthHadAvails: null,
    }),
    computed: {
        ...mapGetters({
            locale: 'locale',
            upperLocale: 'upperLocale',
            selectedService: 'services/getSelectedService',
        }),
        calendarTitle: {
            get: function() {
                return upperFirst(this.getMonthFromDate(this.start));
            },
        },
        previousMonthDescription: {
            get: function() {
                const noAvailsKey = this.monthHasAllowedAvailabilities
                    ? 'available'
                    : 'noAvailable';

                return this.serviceAvailabilitesMessage + ' ' + this.$i18n.t('appt.accessibility.availsCheck', [
                    this.$i18n.t(`appt.accessibility.${noAvailsKey}`),
                    this.calendarTitle,
                    this.$i18n.t('appt.accessibility.availsForMonthPrev', [
                        this.getMonthFromDate(addMonths(this.start, -1)),
                    ]),
                ]);
            },
        },
        nextMonthDescription: {
            get: function() {
                const noAvailsKey = this.monthHasAllowedAvailabilities
                    ? 'available'
                    : 'noAvailable';

                const nextAvailsKeyNext = this.monthHasAllowedAvailabilities
                    ? 'availsForMonthNext'
                    : 'noAvailsForMonthNext';

                return this.serviceAvailabilitesMessage + ' ' + this.$i18n.t('appt.accessibility.availsCheck', [
                    this.$i18n.t(`appt.accessibility.${noAvailsKey}`),
                    this.calendarTitle,
                    this.$i18n.t(`appt.accessibility.${nextAvailsKeyNext}`, [
                        this.getMonthFromDate(addMonths(this.start, 1)),
                    ]),
                ]);
            },
        },
        shouldScreenReaderReadServiceMessage: {
            get: function() {
                return this.previousMonthHadAvails !== null &&
                this.previousMonthHadAvails !== !!this.monthHasAllowedAvailabilities;
            },
            set: function(value) {
                return value;
            },
        },
        serviceAvailabilitesMessage() {
            const messageKey = this.monthHasAllowedAvailabilities
                ? `availabilityMessage${this.upperLocale}`
                : `noAvailabilityMessage${this.upperLocale}`;

            return !this.shouldScreenReaderReadServiceMessage || typeof this.selectedService[messageKey] !== 'string'
                ? ''
                : removeHTMLTags(this.selectedService[messageKey]);
        },
    },
    methods: {
        getMonthFromDate(date) {
            return upperFirst(format(date, 'MMMM YYYY', {
                locale: this.locale === 'fr'
                    ? frLocale
                    : null,
            }));
        },
        navigateMonth(key) {
            this.$emit(key);
            this.previousMonthHadAvails = !!this.monthHasAllowedAvailabilities;
        },
    },
};

</script>
